<template>
  <div class="resetPassword">
    <v-stepper v-model="step">
      <v-stepper-items>
        <v-stepper-content step="1" class="pa-0">
          <v-card class="py-8 px-10">
            <h3 class="mb-2 text-center">重置密碼</h3>
            <v-icon class="d-block text-center">fa-lock</v-icon>
            <span>新密碼</span>
            <v-tooltip bottom nudge-right="105">
              <template v-slot:activator="{ on, attrs }">
                <v-icon small class="ml-2 my-0" v-bind="attrs" v-on="on">fa-question-circle</v-icon>
              </template>
              <span>密碼長度須為 6 到 10 個字，且包含英文字母及數字</span>
            </v-tooltip>
            <v-text-field outlined dense type="password" v-model="password" :rules="[$rules.password]"></v-text-field>
            <span class="d-block text-left">確認新密碼</span>
            <v-text-field outlined dense type="password" v-model="rePassword" :rules="[rules.rePassword]" @keydown.enter="resetPassword"></v-text-field>
            <v-btn rounded block height="40" color="pink" class="mt-2" @click="resetPassword">送出</v-btn>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2" class="pa-0">
          <v-card class="py-8 px-10 text-center">
            <h3 class="mb-2">重置密碼成功</h3>
            <v-icon color="green">fa-check</v-icon>
            <div>您已成功重置密碼</div>
            <div>祝您購物惀快</div>
            <v-btn block rounded class="mt-6" color="pink" to="/">開始購物</v-btn>
          </v-card>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>

<script>
export default {
  data() {
    return {
      step: 1,
      password: '',
      rePassword: '',
      rules: {
        rePassword: value => this.password == value
      }
    }
  },
  computed: {
    formIsValid() {
      return this.$rules.password(this.password) && this.rules.rePassword(this.rePassword)
    }
  },
  methods: {
    resetPassword() {
      if(!this.formIsValid) {
        return
      }
      this.axios.post('/member/email/verify/forget', {
        token: this.$route.query.token,
        password: this.password
      }).then(response => {
        this.step = 2
        this.$store.dispatch('user/setToken', `Bearer ${response.data.token}`)
        this.$store.dispatch('user/getUserInformation')
      }).catch(e => {
        if(e.response.data.message.includes('The token is wrong')) {
          this.$router.push('/forget/expired')
        }
        else if(e.response.data.message.includes('The token is expired')) {
          this.$router.push('/forget/expired')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.resetPassword {
  min-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .v-card {
    width: 400px;
    span {
      font-size: 12px;
    }
    .v-icon {
      margin: 20px 0;
      font-size: 70px;
    }
  }
}
</style>